module.exports = __webpack_public_path__ + "img/colonnade-dark.22584439.png";